import {
  SELECIONAR_PASSAGEIRO
} from '../../actions/types';

const initialState = null

export default function reducerAdicionarPassageiros (state = initialState, action) {
  switch (action.type) {
    case SELECIONAR_PASSAGEIRO: {
      return action.payload
    }
    default:
      return state
  }
}
